import { createSlice } from '@reduxjs/toolkit';
import {
  doDownloadCatchmentResult,
  doDownloadVillageResult,
  downloadSummary,
  getAhsMArkers,
  getResultAreaProfiling,
} from './area-profilisng.asyncAction';

const initialState = {
  description: '',
  message: '',
  data: {},
  marker: {
    list: [],
    meta: {
      total: 0,
      page: 1,
      limit: 30,
      nextPage: 2,
      prevPage: 1,
    },
  },
  download: {
    village_url: '',
    village_filename: '',
    catchment_url: '',
    catchment_filename: '',
  },
  isShowPOI: false,
  isShowPolygon: false,
  step: 1,
  status_GET_RESULT: 'IDLE',
  status_GET_MARKERS: 'IDLE',
  status_DOWNLOAD_VILLAGE: 'IDLE',
  status_DOWNLOAD_CATCHMENT: 'IDLE',
  status_DOWNLOAD_SUMMARY: 'IDLE',
  tabActive: 'AREA',
};
export const areaSlice = createSlice({
  name: 'LI/DANONE/AREA-PROFILING',
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    resetStatus: (state, action) => {
      const { payload } = action;
      switch (payload?.type) {

        case 'status_DOWNLOAD_VILLAGE':
          state.status_DOWNLOAD_VILLAGE = 'IDLE';
          break;
        case 'status_DOWNLOAD_CATCHMENT':
          state.status_DOWNLOAD_CATCHMENT = 'IDLE';
          break;
        case 'status_DOWNLOAD_SUMMARY':
          state.status_DOWNLOAD_SUMMARY = 'IDLE';
          break;
        default:
          state.status_GET_RESULT = 'IDLE';
          state.status_GET_MARKERS = 'IDLE';
          break;
      }
    },
    showPOI: (state, action) => {
      state.isShowPOI = action.payload;
    },
    showPolygon: (state, action) => {
      state.isShowPolygon = action.payload;
    },
    setStep: (state, action) => {
      state.step = action.payload;
    },
    setTabActive: (state, action) => {
      state.tabActive = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getResultAreaProfiling.pending, (state) => {
        state.status_GET_RESULT = 'LOADING';
      })
      .addCase(getResultAreaProfiling.fulfilled, (state, action) => {
        state.status_GET_RESULT = 'SUCCESS';
        state.data = action.payload.data;
      })
      .addCase(getResultAreaProfiling.rejected, (state, action) => {
        state.status_GET_RESULT = 'FAILED';
        state.message = action.error.message;
      })
      .addCase(getAhsMArkers.pending, (state) => {
        state.status_GET_MARKERS = 'LOADING';
        state.marker.meta = {
          total: 0,
          page: 1,
          limit: 30,
          nextPage: 2,
          prevPage: 1,
        };
      })
      .addCase(getAhsMArkers.fulfilled, (state, action) => {
        state.status_GET_MARKERS = 'SUCCESS';
        state.marker.list = action.payload.data;
        state.marker.meta = {
          total: action.payload.total,
          page: action.payload.page,
          limit: action.payload.limit,
          nextPage: action.payload.next_page,
          prevPage: action.payload.prev_page,
        };
      })
      .addCase(getAhsMArkers.rejected, (state, action) => {
        state.status_GET_MARKERS = 'FAILED';
        state.message = action.error.message;
      })
      .addCase(downloadSummary.pending, (state) => {
        state.status_DOWNLOAD_SUMMARY = 'LOADING';
      })
      .addCase(downloadSummary.fulfilled, (state) => {
        state.status_DOWNLOAD_SUMMARY = 'SUCCESS';
      })
      .addCase(downloadSummary.rejected, (state, action) => {
        state.status_DOWNLOAD_SUMMARY = 'FAILED';
        state.message = action.error.message;
      })
      .addCase(doDownloadVillageResult.pending, (state) => {
        state.status_DOWNLOAD_VILLAGE = 'LOADING';
      })
      .addCase(doDownloadVillageResult.fulfilled, (state, action) => {
        state.download.village_url = action.payload.url;
        state.download.village_filename = action.payload.filename;
        state.status_DOWNLOAD_VILLAGE = 'SUCCESS';
      })
      .addCase(doDownloadVillageResult.rejected, (state, action) => {
        state.status_DOWNLOAD_VILLAGE = 'FAILED';
        state.message = action.error.message;
      })
      .addCase(doDownloadCatchmentResult.pending, (state) => {
        state.status_DOWNLOAD_CATCHMENT = 'LOADING';
      })
      .addCase(doDownloadCatchmentResult.fulfilled, (state, action) => {
        state.download.catchment_url = action.payload.url;
        state.download.catchment_filename = action.payload.filename;
        state.status_DOWNLOAD_CATCHMENT = 'SUCCESS';
      })
      .addCase(doDownloadCatchmentResult.rejected, (state, action) => {
        state.status_DOWNLOAD_CATCHMENT = 'FAILED';
        state.message = action.error.message;
      }),
});

export const { reducer: areaProfilingReducer, actions: areaProfilingActions } =
  areaSlice;
